export type TOrganizationModuleSate = Record<string, unknown>

export const getInitialOrganizationState = (): TOrganizationModuleSate => {
    return {}
}

const moduleState = getInitialOrganizationState()

export default moduleState
